import { render, staticRenderFns } from "./GestionHidrocarburosMarcarLlegada.vue?vue&type=template&id=f85dddca"
import script from "./GestionHidrocarburosMarcarLlegada.vue?vue&type=script&lang=js"
export * from "./GestionHidrocarburosMarcarLlegada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports